import { ODataOptions } from 'src/util/ODataBuilder';
import BaseApi from './BaseApi';
import LeaseGenerationForm from 'src/models/leasing/LeaseGenerationForm';
// import { ODataOptions } from 'src/util/ODataBuilder';

export interface ILeaseGeneration {
    getLeaseGenerationForm(clientNumber: number, projectId: number, ownerId: number, leaseFormId: number, leaseType: number, jwt: string): Promise<object>;
    createLeaseGenerationForm(clientNumber: number, projectId: number, ownerId: number, leaseData: LeaseGenerationForm, jwt: string): Promise<object>;
    getOwnerData(clientNumber: number, projectId: number, id: number, jwt: string): Promise<object>;
    getLeaseGenerationFormCollection(clientNumber: number, projectId: number, ownerId: number, leaseType: number, jwt: string): Promise<object>;
    updateLeaseGenerationForm(
        clientNumber: number,
        projectNumber: number,
        ownerId: number,
        leaseData: LeaseGenerationForm,
        jwt: string
    ): Promise<object>;
    getAgreementsByUser(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    getGeneratedContracts(clientNumber: number, projectNumber: number, options: ODataOptions, jwt: string): Promise<object>;
    setAgreementStatus(
        clientNumber: number,
        projectNumber: number,
        ownerId: number,
        leaseFormId: number,
        leaseType: number,
        status: number,
        explanation: string,
        jwt: string
    ): Promise<object>;
}

export default class LeaseGeneration extends BaseApi implements ILeaseGeneration {
    constructor(baseURL: string) {
        super(baseURL);
    }

    getLeaseGenerationForm = (clientNumber: number, projectId: number, ownerId: number, leaseFormId: number, leaseType: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/leasegeneration/owner/${ownerId}/leaseForm/${leaseFormId}`,
            jwt
        );
    };

    getLeaseGenerationFormCollection = (clientNumber: number, projectId: number, ownerId: number, leaseType: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/leasegeneration/owner/${ownerId}/leaseForm`, jwt);
    };

    createLeaseGenerationForm = (clientNumber: number, projectId: number, ownerId: number, leaseData: LeaseGenerationForm, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/leasegeneration/owner/${ownerId}`, leaseData, jwt);
    };

    getOwnerData = (clientNumber: number, projectId: number, id: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/leasegeneration/owner/${id}`, jwt);
    };

    updateLeaseGenerationForm = (clientNumber: number, projectNumber: number, ownerId: number, leaseData: LeaseGenerationForm, jwt: string) => {
        console.log('leasedata', leaseData);
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/leasegeneration/owner/${ownerId}`,
            leaseData,
            jwt
        );
    };

    getAgreementsByUser = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/leasegeneration/by-userId`, jwt);
    };

    getGeneratedContracts = (clientNumber: number, projectNumber: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/leases/paged/${options.toString()}`, jwt);
    };

    setAgreementStatus = (
        clientNumber: number,
        projectNumber: number,
        ownerId: number,
        leaseFormId: number,
        leaseType: number,
        status: number,
        explanation: string,
        jwt: string
    ) => {
        console.log('set agree api');

        // tslint:disable-next-line: max-line-length
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/leasegeneration/owner/${ownerId}/leaseForm/${leaseFormId}/agreement-status/`,
            { leaseStatus: status, leaseType, explanation },
            jwt
        );
    };
}



// WEBPACK FOOTER //
// ./src/api/LeaseGeneration.ts